import { QuotaUxTrigger } from 'features/hubspot/types'
import { QuotaResult } from 'features/quotas/types'
import WouldExceedQuotaDialog from 'features/quotas/ui/WouldExceedQuotaDialog'
import React, { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

function MapsHardQuotaModal({
  variant,
  quota,
  quotaUxTrigger,
  open,
  onCloseModal
}: {
  variant: 'create' | 'duplicate' | 'share' | 'moreInfo'
  quota?: QuotaResult
  open?: boolean
  quotaUxTrigger: QuotaUxTrigger
  onCloseModal: () => void
}) {
  const titleVariant = variant === 'moreInfo' ? 'create' : variant

  const quotaEventMetric = useMemo(() => {
    return (
      quota?.eventMetricQuotaType && {
        quota: quota?.eventMetricQuotaType,
        quota_ux_trigger: quotaUxTrigger
      }
    )
  }, [quota?.eventMetricQuotaType, quotaUxTrigger])

  const messages = useMemo(() => {
    return {
      title: <FormattedMessage id={`maps.quota.wouldExceedQuotaModal.${variant}.title`} />,
      message: <FormattedMessage id={`maps.quota.wouldExceedQuotaModal.${titleVariant}.message`} />,
      alertMessage: (
        <FormattedMessage
          id={
            variant === 'share'
              ? 'maps.quota.wouldExceedQuotaModal.share.alertMessage'
              : 'maps.quota.wouldExceedQuotaModal.alertMessage'
          }
        />
      ),
      quotaTitle: <FormattedMessage id="maps.quota.wouldExceedQuotaModal.quotaTitle" />
    }
  }, [titleVariant, variant])

  return (
    <WouldExceedQuotaDialog
      open={open ?? true}
      onCloseModal={onCloseModal}
      title={messages.title}
      message={messages.message}
      alertMessage={messages.alertMessage}
      quota={quota}
      quotaTitle={messages.quotaTitle}
      quotaRequestType={quota?.quotasRequestType}
      quotaEventMetric={quotaEventMetric}
    />
  )
}

export default MapsHardQuotaModal
